import emailjs from '@emailjs/browser';

// Contact information - Update with your actual details
export const contactInfo = {
  email: "junaidhossain77349@gmail.com",
  phone: "+880 1333662185",
  whatsapp: "+880 1791512216",
  location: "Dhaka, Bangladesh",
  
  // Social media links
  social: {
    github: "https://github.com/Junaid8217",
    linkedin: "https://www.linkedin.com/in/md-junaid-hossain-623879360",
    facebook: "https://www.facebook.com/junaid.hossain.33821",
    
  },
  
  // Professional links
  resume: "/resume.pdf", // Place your resume in the public folder
  portfolio: "https://yourportfolio.com"
};

// EmailJS Configuration
// You need to replace these with your actual EmailJS credentials
const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_xif5a1a', // Replace with your EmailJS service ID
  TEMPLATE_ID: 'template_u8ltjt5', // Replace with your EmailJS template ID
  PUBLIC_KEY: 'zsUZ91XDjmj4H0yjk' // Replace with your EmailJS public key
};

// Contact form submission handler
export const submitContactForm = async (formData) => {
  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      subject: formData.subject,
      message: formData.message,
      reply_to: formData.email
    };

    await emailjs.send(
      EMAILJS_CONFIG.SERVICE_ID,
      EMAILJS_CONFIG.TEMPLATE_ID,
      templateParams,
      EMAILJS_CONFIG.PUBLIC_KEY
    );

    return {
      success: true,
      message: "Message sent successfully!"
    };
  } catch (error) {
    console.error("EmailJS error:", error);
    return {
      success: false,
      message: "Failed to send message."
    };
  }
};


// Helper functions
export const openEmail = () => {
  window.open(`mailto:${contactInfo.email}`, '_blank');
};

export const openPhone = () => {
  window.open(`tel:${contactInfo.phone}`, '_blank');
};

export const openWhatsApp = (message = '') => {
  const encodedMessage = encodeURIComponent(message || 'Hello! I found your portfolio and would like to get in touch.');
  const phoneNumber = contactInfo.whatsapp.replace(/\s+/g, '').replace('+', '');
  window.open(`https://wa.me/${phoneNumber}?text=${encodedMessage}`, '_blank');
};

export const openSocialLink = (platform) => {
  if (contactInfo.social[platform]) {
    window.open(contactInfo.social[platform], '_blank');
  }
};